import { AutomationsListItemFragment, ConditionEvaluationStatus } from 'shared/types/graphql';
import { getIsChildAutomation } from '../hooks';

type IsConditionalChildAutomationInput = Pick<
  AutomationsListItemFragment,
  'triggerType' | 'event' | 'childRunEvaluationStatus' | 'conditionSets'
>;

export const isConditionalChildAutomation = (automation: IsConditionalChildAutomationInput | undefined): boolean => {
  return (
    !!automation &&
    getIsChildAutomation({ automationType: automation.event, triggerType: automation.triggerType }) &&
    automation.childRunEvaluationStatus === ConditionEvaluationStatus.Evaluate &&
    automation.conditionSets?.some((conditionSet) => conditionSet.conditions?.length)
  );
};
